<template>
  
    <v-dialog
      
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn elevation="2" small color="warning" class="ml-1 my-2 my-md-0" v-bind="attrs" v-on="on" @click="btnSalida">
            <v-icon>mdi-car-arrow-right</v-icon> Salida
          </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="warning">
          <v-btn icon dark @click="cerrarDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Salida de vehiculo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn 
              dark
              text
              @click="imprimir"
              v-show="this.pagina==2"
            > <v-icon class="mr-2">mdi-printer</v-icon>
                 Imprimir
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container v-show="this.pagina==1">
          <v-row>
            <v-col>
              <div class="d-flex flex-column justify-center align-center" style="height: 80vh">
                <h3>¿Deseas registrar salida de {{item.client.name}} con su vehículo?</h3>
                <div class="d-flex flex-row mt-5">
                  <v-btn color="red" dark @click="cancelar()">No</v-btn>
                  <v-btn color="success" @click="Salida()" class="ml-3">Si</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-show="this.pagina==2">
          
          <div class="ticket" id="ticketSalida">
            <center><img src="../../assets/imgs/favicon.png" alt="Logo Empresa" height="80px" /></center>
            <v-list>
              <br><center><b>Orden de salida</b></center><br>
              <v-list-item-group>
                <v-text><b>Fecha:</b> {{hoy}}</v-text>
              </v-list-item-group>
              <v-list-item-group>
                <v-text><b>Cliente:</b> {{item.client.name + ' ' + item.client.first_lastname + ' ' + (item.client.second_lastname || '')}}</v-text>
              </v-list-item-group>
              <v-list-item-group v-if="item.vehicle.model">
                <v-text><b>Vehículo:</b> {{item.vehicle.model.name + ' - ' + item.vehicle.year}}</v-text>
              </v-list-item-group>
              <v-list-item-group v-if="item.vehicle.model">
                <v-text><b>Marca:</b> {{item.vehicle.model.brand.name}}</v-text>
              </v-list-item-group>
              <v-list-item-group>
                <v-text><b>Color:</b> {{item.vehicle.colour}}</v-text>
              </v-list-item-group>
              <v-divider class="my-10"></v-divider>
              <v-list-item-group>
                <v-text><b>Orden de servicio:</b> {{item.order}}</v-text>
              </v-list-item-group>
              <v-list-item-group>
                <v-text><b>Mecánico responsable:</b> {{item.services[0].mechanics[0].name + ' ' +item.services[0].mechanics[0].first_lastname +' '+ (item.services[0].mechanics[0].second_lastname||'')}}</v-text>
              </v-list-item-group>
              <v-list-item-group>
                <v-text><b>Servicio:</b></v-text>
                <ul>
                  <li v-for="service in item.services" :key="service._id">
                    {{service.service.name}}
                  </li>
                </ul>
              </v-list-item-group>
              <!-- <v-list-item-group>
                <v-text><b>Observaciones:</b> {{item.detail}}</v-text>
              </v-list-item-group> -->
              <v-list-item-group class="mt-10">
                <center><v-text>_________________________________________</v-text></center>
                <center>Firma de salida</center>
              </v-list-item-group>
            </v-list>
          </div>
        </v-container>
      </v-card>
    </v-dialog>

  
</template>
<script>
import ApiService from "../../services/apis";
export default {
  name: "Salida",
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      date: null,
      promesa:null,
      menu: false,
      menu2:false, 
      nuevo:false,
      hoy: null,
    };
  },
  props:{
    item:null,
    pagina:null
  },
  watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    created(){
      var moment = require('moment')
      moment.locale('es')
      this.hoy=moment().format('L');
      
    },
    methods: {
      save (date) {
        this.$refs.menu.save(date)
      },
      cerrarDialog(){
        window.location.reload()
      },
      imprimir() {
        let imprimir = "";
        imprimir = document.getElementById("ticketSalida");
        var ventana = "";
        ventana = window.open("", "PRINT", "height=400,width=600");
        ventana.document.write(
          "<html><head><title></title>"
        );
        ventana.document.write('<link rel="stylesheet" href="./estilos.css">');
        ventana.document.write("</head><body >");
        ventana.document.write(imprimir.innerHTML);
        ventana.document.write("</body></html>");
        ventana.document.close();
        ventana.focus();
        setTimeout(() => {
          ventana.print();
          window.location.reload()
        }, 2000);
      },
      btnSalida(){
        this.pagina=1
      },
      Salida(){
        ApiService.ordenEditar(this.item._id, {status: 4}).then(() => {
          this.pagina=2

        });
      },
      cancelar(){
        //this.dialog=false
        window.location.reload()
        //this.$forceUpdate()
      }
    },
};
</script>